import React from 'react';
import PropTypes from 'prop-types';

import Input from '../../../common/input';
import Icon, { GLYPHS } from '../../../common/icon';
import CurrencyInput from '../../../common/currencyInput';
import CheckboxSwitch from '../../../common/checkboxSwitch';
import AdminActionButton from '../../shared/Buttons/AdminActionButton';
import ShopCode from './ShopCode';
import Select from '../../../common/select';

const HourlyWageRules = ({ handleSubmit, submitting, pristine, valid, isEnabled, shop }) => (
  <div className="c-wrapper">
    <div className="u-max-width-710 u-margin-auto">
      <div className="c-inner-wrapper u-pt">
        <form onSubmit={handleSubmit}>
          <fieldset disabled={submitting}>
            <div className="u-ph">
              <div className="layout u-mb">
                <CheckboxSwitch
                  name="calculateHourlyWages"
                  id="calculateHourlyWages"
                  label="Calculate Hourly Wages"
                  wrapperClass="layout__item"
                />
              </div>
              <div className="layout" display-if={isEnabled}>
                <div className="layout__item">
                  <div className="c-label c-label--light">Minimum Wage</div>
                  <CurrencyInput className="c-input" name="minimumWage" currency={shop && shop.currency} />
                </div>
                <div className="layout__item">
                  <div className="c-label c-label--light">First Threshold</div>
                  <Input
                    prefix="%"
                    className="c-input"
                    name="lowerOvertimeCommissionPercentage"
                    type="text"
                    placeholder="First Threshold"
                    format={value => (value || 0) * 100}
                    parse={value => (value || 0) / 100}
                  />
                </div>
                <div className="layout__item">
                  <div className="c-label c-label--light">Second Threshold</div>
                  <Input
                    prefix="%"
                    className="c-input"
                    name="upperOvertimeCommissionPercentage"
                    type="text"
                    placeholder="Second Threshold"
                    format={value => (value || 0) * 100}
                    parse={value => (value || 0) / 100}
                  />
                </div>
                <div className="layout__item">
                  <div className="c-label c-label--light">Regular hours per day</div>
                  <Input className="c-input" name="regularHours" type="text" placeholder="Regular Hours per day" />
                </div>
                <div className="layout__item">
                  <div className="c-label c-label--light">Overtime Hours</div>
                  <Input className="c-input" name="upperOvertimeHours" type="text" placeholder="Overtime Hours" />
                </div>
                <div className="layout__item">
                  <div className="c-label c-label--light">Consecutive Days</div>
                  <Input className="c-input" name="consecutiveDays" type="text" placeholder="Consecutive Days" />
                </div>
                <div className="layout__item">
                  <div className="c-label c-label--light">Weekly Hours</div>
                  <Input className="c-input" name="weeklyHours" type="text" placeholder="Weekly Hours" />
                </div>
                <div className="layout__item">
                  <div className="c-label c-label--light">Location number</div>
                  <Input className="c-input" name="locationNumber" type="text" placeholder="Ex. 501" />
                </div>
                <div className="layout__item">
                  <div className="c-label c-label--light">Shop number</div>
                  <Input className="c-input" name="shopNumber" type="text" placeholder="Ex. 50101" />
                </div>
                <div className="layout__item">
                  <div className="c-label c-label--light">Shop Type</div>
                  <Select
                    className="c-select"
                    name="shopType"
                    options={[{
                      label: 'Barbershop',
                      value: 'barbershop',
                    }, {
                      label: 'Salon',
                      value: 'salon',
                    }]}
                  />
                </div>
                <CheckboxSwitch
                  name="adpReport"
                  id="adpReport"
                  label="ADP Import Sheet Generator"
                  wrapperClass="layout__item"
                />
                <ShopCode />
              </div>
            </div>
            <div className="c-separator u-mv" />
            <div className="u-text-right">
              <AdminActionButton
                type="submit"
                className="c-btn c-btn--primary c-btn--icon"
                disabled={pristine || !valid}
              >
                <Icon glyph={GLYPHS.save} size="medium" />
                <span className="c-btn__text">Save</span>
              </AdminActionButton>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
);

HourlyWageRules.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  isEnabled: PropTypes.bool.isRequired,
  shop: PropTypes.object,
};

HourlyWageRules.defaultProps = {
  shop: null,
};

export default HourlyWageRules;
